<template>
  <v-dialog v-model="dialog" @keydown.esc="cancel" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">URL選択</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            locale="ja-jp"
            loading-text="読込中"
            hide-default-footer
            :show-select="isShowSelect"
            item-key="imageNo"
          >
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="isShowAgreeButton"
          class="mx-2"
          color="primary"
          @click.native="agree"
          :disabled="selected.length < 1"
        >
          貼付け
        </v-btn>
        <v-btn class="mx-2" color="primary" @click.native="cancel">
          {{ cancelButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "SelectUrls",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    items: [],
    selected: []
  }),
  props: {
    /**
     * チェックボックス表示
     */
    isShowSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * 選択ボタン表示
     */
    isShowAgreeButton: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    headers() {
      return [
        {
          text: "ファイル",
          value: "file",
          sortable: false
        },
        {
          text: "タイトル",
          value: "imageTitle",
          sortable: false
        },
        {
          text: "URL",
          value: "url",
          sortable: false
        }
      ];
    },
    cancelButtonText() {
      let buttonText = "キャンセル";
      if (!this.isShowAgreeButton) {
        buttonText = "戻る";
      }
      return buttonText;
    }
  },
  methods: {
    open(files) {
      this.dialog = true;
      this.items = [];
      files.map(file => {
        this.items.push({
          imageNo: file.imageNo,
          file: file.imageFileName,
          imageTitle: file.imageTitle,
          url: file.url //"http://www.pref.kagoshima.jp/index.html"
        });
      });
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.$parent.selectedUrls = this.selected;
      this.selected = [];
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.selected = [];
      this.resolve(false);
      this.dialog = false;
    }
  },
  watch: {
    dialog(val) {
      val || this.cancel();
    }
  }
};
</script>
